__turbopack_context__.v({
  "blocksBackgroundColor": "Header-module-scss-module__wf7gwq__blocksBackgroundColor",
  "blocksFontColor": "Header-module-scss-module__wf7gwq__blocksFontColor",
  "darkIcon": "Header-module-scss-module__wf7gwq__darkIcon",
  "eyeglass": "Header-module-scss-module__wf7gwq__eyeglass",
  "formGroup": "Header-module-scss-module__wf7gwq__formGroup",
  "inlineBlock": "Header-module-scss-module__wf7gwq__inlineBlock",
  "landmark": "Header-module-scss-module__wf7gwq__landmark",
  "mainHeader": "Header-module-scss-module__wf7gwq__mainHeader",
  "searchForm": "Header-module-scss-module__wf7gwq__searchForm",
  "searchIcon": "Header-module-scss-module__wf7gwq__searchIcon",
  "searchText": "Header-module-scss-module__wf7gwq__searchText",
  "secondaryNavBackgroundColor": "Header-module-scss-module__wf7gwq__secondaryNavBackgroundColor",
  "skip": "Header-module-scss-module__wf7gwq__skip",
  "socialNavItems": "Header-module-scss-module__wf7gwq__socialNavItems",
  "speech": "Header-module-scss-module__wf7gwq__speech",
  "themeBackgroundColor": "Header-module-scss-module__wf7gwq__themeBackgroundColor",
  "themeFontColor": "Header-module-scss-module__wf7gwq__themeFontColor",
  "titleAndSocial": "Header-module-scss-module__wf7gwq__titleAndSocial",
  "titleAndSocialTitleInvisible": "Header-module-scss-module__wf7gwq__titleAndSocialTitleInvisible",
  "transitionEnter": "Header-module-scss-module__wf7gwq__transitionEnter",
  "transitionEnterActive": "Header-module-scss-module__wf7gwq__transitionEnterActive",
  "transitionEnterDone": "Header-module-scss-module__wf7gwq__transitionEnterDone",
  "transitionExit": "Header-module-scss-module__wf7gwq__transitionExit",
  "transitionExitActive": "Header-module-scss-module__wf7gwq__transitionExitActive",
  "transitionExitDone": "Header-module-scss-module__wf7gwq__transitionExitDone",
});
